import { Logo } from "@/components/comiq/Logo";
import { Check, Cloud, Eye } from "lucide-react";

// Restrained respondent header: quiet brand, visible progress, obvious autosave status.
// preview=true (hanya dipakai mode "Buka sebagai Responden") mengganti chip autosave
// dengan indikator pratinjau dan menambahkan banner "Mode Preview".
export const SurveyHeader = ({ current, total, saved = true, preview = false }) => {
  const pct = Math.round((current / total) * 100);
  return (
    <header
      className="sticky top-0 z-30 border-b backdrop-blur"
      style={{ background: "rgba(245,241,232,0.85)", borderColor: "#E4DCCB" }}
    >
      {preview && (
        <div
          data-testid="preview-mode-banner"
          className="border-b px-4 py-1.5 text-center text-xs font-semibold"
          style={{ background: "#FEF3C7", color: "#92400E", borderColor: "#FDE68A" }}
        >
          <Eye size={12} className="-mt-0.5 mr-1 inline" /> Mode Preview — jawaban tidak disimpan
        </div>
      )}
      <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-3.5">
        <Logo />
        {preview ? (
          <div data-testid="preview-mode-chip" className="flex items-center gap-1.5 text-xs font-medium" style={{ color: "#B45309" }}>
            <Eye size={14} /> Mode pratinjau
          </div>
        ) : (
          <div
            data-testid="autosave-status"
            className="flex items-center gap-1.5 text-xs font-medium"
            style={{ color: saved ? "#15803D" : "#6A6256" }}
          >
            {saved ? <Check size={14} strokeWidth={3} /> : <Cloud size={14} />}
            {saved ? "Tersimpan otomatis" : "Menyimpan…"}
          </div>
        )}
      </div>
      <div className="mx-auto max-w-3xl px-5 pb-3">
        <div className="mb-1.5 flex items-center justify-between text-xs" style={{ color: "#6A6256" }}>
          <span data-testid="progress-label">
            Pertanyaan {current} dari {total}
          </span>
          <span>{pct}%</span>
        </div>
        <div className="h-1.5 w-full overflow-hidden rounded-full" style={{ background: "#E4DCCB" }}>
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{ width: `${pct}%`, background: "#F2541B" }}
            data-testid="progress-bar"
          />
        </div>
      </div>
    </header>
  );
};
